import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import clsx from 'clsx';
import { Image } from '../Image/Image.js';
import { Picture } from '../Picture/Picture.js';

// Use Image component instead of img tag.
const CoverImage = /*#__PURE__*/React.forwardRef(function CoverImage({
  className,
  src,
  maxWidth,
  maxHeight,
  alt,
  ...rest
}, ref) {
  return jsx("div", {
    style: {
      maxWidth
    },
    className: "h-full w-full",
    children: Array.isArray(src) ? jsx(Picture, {
      ...rest,
      ref: ref,
      alt: alt,
      sources: src,
      config: [{
        w: maxWidth,
        h: maxHeight
      }],
      className: clsx('object-cover', className)
    }) : jsx(Image, {
      src: src,
      config: {
        w: maxWidth,
        h: maxHeight
      },
      className: clsx('object-cover', className),
      sizes: `(min-width: ${maxWidth}px) ${maxWidth}px, 100vw`,
      alt: alt,
      ...rest,
      ref: ref
    })
  });
});

export { CoverImage };
